import { gql } from '@apollo/client'

export const SET_COLOR_PALETTE = gql`
    mutation SetColorPalette($company_id:ID!, $product_id: ID!, $colors: [InputColor]!) {
        setColorPalette(company_id:$company_id, product_id:$product_id, colors:$colors)
    }
`
